import React from 'react';
import './Contact.css';

function Contact() {
  return (
    <section className="contact-section" id="contato">
      <div className="contact-container">
        <h2>CONTATO</h2>
        <p className="contact-subtitle">
          Entre em contato com a Edifica 3D para tirar dúvidas, solicitar orçamentos ou apresentar suas sugestões personalizadas. Estamos sempre disponibilizados.
        </p>
        
        <div className="contact-form-wrapper">
          <div className="contact-form-group">
            <input type="text" placeholder="Seu Nome" />
            <input type="email" placeholder="Seu E-mail" />
            <input type="tel" placeholder="Seu Telefone" />
          </div>
          <button className="contact-button">Enviar Agora</button>
        </div>

        <div className="contact-channels">
          <h3>CANAIS DE CONTATO E NOSSAS REDES</h3>
          <div className="channels-grid">
            <div className="channel-item">
              <span className="channel-icon">📍</span>
              <p>Rua Jose do Arc Preto - 07</p>
            </div>
            <div className="channel-item">
              <span className="channel-icon">📞</span>
              <p>+55 17 98424 3472</p>
            </div>
            <div className="channel-item">
              <span className="channel-icon">✉️</span>
              <p>contato@edifica3d.com.br</p>
            </div>
            <div className="channel-item">
              <span className="channel-icon">🌐</span>
              <p>instagram.com/edifica3d</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
